import { Star } from 'lucide-react';

export const DifficultyStars = ({ difficulty, interactive = false, onChange, size = 'md' }) => {
  const sizes = {
    sm: 'w-4 h-4',
    md: 'w-5 h-5',
    lg: 'w-6 h-6',
  };

  const handleClick = (value) => {
    if (interactive && onChange) {
      onChange(value);
    }
  };

  return (
    <div className="flex items-center gap-1" data-testid="difficulty-stars">
      {[1, 2, 3, 4, 5].map((value) => (
        <button
          key={value}
          type="button"
          onClick={() => handleClick(value)}
          disabled={!interactive}
          className={`${interactive ? 'cursor-pointer hover:scale-110' : 'cursor-default'} transition-transform difficulty-star`}
          data-testid={`star-${value}`}
        >
          <Star
            className={`${sizes[size]} ${
              value <= difficulty
                ? 'text-worldplate-accent fill-worldplate-accent'
                : 'text-stone-300'
            }`}
          />
        </button>
      ))}
    </div>
  );
};

export default DifficultyStars;
